import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import { Box } from '~/components/elements/Box'
import { LabelingContainer } from '~/components/elements/LabelingContainer'
import {
  BrandAccountSelector,
  type BrandAccountSelectorProps,
} from '~/components/features/BrandAccountSelector'
import {
  type BrandAccount,
  useCommonQueryBrandAccounts,
  useCommonQueryCurrentBrandAccount,
} from '~/hooks/useCommonQuery'
import { useCurrentBrandAccountSurveysQueryData } from '~/hooks/useCurrentBrandAccountSurveysQuery'
import { useIsCoreMember } from '~/hooks/useIsCoreMember'
import { SurveyOp } from '~/utils'

import styles from './NavigationBrandAccountSelector.css'

export const NavigationBrandAccountSelector = () => {
  const { t } = useTranslation()
  const currentBrandAccount = useCommonQueryCurrentBrandAccount()
  const brandAccounts = useCommonQueryBrandAccounts()
  const brandAccountSurveys = useCurrentBrandAccountSurveysQueryData()
  const isCoreMember = useIsCoreMember()

  const availableBrandAccounts = React.useMemo(
    () =>
      isCoreMember
        ? brandAccounts
        : brandAccounts.filter(
            (brandAccount) =>
              brandAccount.isSurveyEditor === true ||
              brandAccountSurveys.some((survey) =>
                SurveyOp.hasMappedBrandGroupsWithBrands(survey),
              ),
          ),
    [brandAccountSurveys, brandAccounts, isCoreMember],
  )

  const navigate = useNavigate()
  const handleBrandAccountSelectorChange = React.useCallback<
    EH<BrandAccountSelectorProps<BrandAccount>, 'onChange'>
  >(
    (brandAccountId) => {
      navigate(compile('brandAccount', { brandAccountId }))
    },
    [navigate],
  )

  return (
    <Box className={styles.root}>
      <LabelingContainer label={t('brand_account')} labelVariant="small">
        <BrandAccountSelector
          brandAccounts={availableBrandAccounts}
          className={styles.itemSelector}
          value={currentBrandAccount?.id ?? null}
          onChange={handleBrandAccountSelectorChange}
        />
      </LabelingContainer>
    </Box>
  )
}
